<template>
    <v-flex xs12>
        <v-container grid-list-lg>
            <v-layout row wrap>
                <v-flex xs12>
                    <h4 class="primary--text">Apólices Anteriores?
                        <span v-if="model.apolicesAnteriores" class="green--text">SIM</span>
                        <span v-else class="red--text">NÃO</span>
                    </h4>
                </v-flex>
                <template v-if="model.apolicesAnteriores">
                    <v-flex xs12 sm6>
                        <v-text-field label="Seguradora" :value="model.seguradora" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field label="Corretora" :value="model.corretora" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <!-- <h4 class="primary--text">Vencimento</h4>
                        <br> -->
                        <v-text-field label="Vencimento" :value="toLocaleDateString(model.vencimento)" prepend-icon="event" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="model.taxaApoliceAnterior != 0">
                        <h4 class="primary--text">Taxa no seguro anterior?</h4>
                        <template>
                            <v-flex xs12 sm4 class="pl-0 pb-0">
                                <v-text-field label="Taxa" :value="toPercentTaxaString(model.taxaApoliceAnterior)" disabled></v-text-field>
                            </v-flex>
                            <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                        </template>
                    </v-flex>
                    <v-flex xs12 v-else-if="model.descontoApoliceAnterior != 0">
                        <h4 class="primary--text">Desconto no seguro anterior?</h4>
                        <template>
                            <v-flex xs12 sm4 class="pl-0 pb-0">
                                <v-text-field label="Desconto" :value="toPercentString(model.descontoApoliceAnterior)" disabled></v-text-field>
                            </v-flex>
                            <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                        </template>
                    </v-flex>
                    <v-flex xs12 class="pt-0">
                        <h4 class="primary--text">Cobertura de roubo?
                            <span v-if="model.coberturaRoubo" class="green--text">SIM</span>
                            <span v-else class="red--text">NÃO</span>
                        </h4>
                    </v-flex>
                    <template v-if="model.coberturaRoubo">
                        <v-flex xs12 sm4>
                            <v-text-field label="Taxa" :value="toPercentString(model.taxaRouboApoliceAnterior)" disabled></v-text-field>
                        </v-flex>
                        <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                    </template>
                </template> 
                <v-flex xs12>
                    <h4 class="primary--text">Houve ocorrência de Sinistros?
                        <span v-if="model.ocorreuSinistro" class="green--text">SIM</span>
                        <span v-else class="red--text">NÃO</span>
                    </h4>
                </v-flex>
                <v-flex xs12 v-if="model.ocorreuSinistro">
                    <v-data-table :headers="cabecalhoGridSinistros"
                    hide-actions
                    :items="model.sinistros"
                    no-data-text="Nenhum sinistro foi adicionado">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.mercadoria.descricao }}</td>
                            <td class="text-xs-left">{{ toMoneyString(props.item.valorPrejuizo) }}</td>
                            <td class="text-xs-left">{{ props.item.causaDoSinistro }}</td>
                            <!-- <td class="text-xs-left">{{ getSiglaEstado(props.item.estado, props.index) }}</td>
                            <td class="text-xs-left">{{ getNomeCidade(props.item.cidade, props.index) }}</td> -->
                            <td class="text-xs-left">{{ toLocaleDateString(props.item.data) }}</td>
                            <!-- <td class="text-xs-left">{{ props.item.obs }}</td> -->
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
</template>

<script>
import CustomFormat from '@/helpers/custom-format'
import axios from 'axios'

export default {
  name: 'segurosanteriores',
  props: ['model'],
  data: () => {
      return {
        estados: [],
        cidades: [],
        cabecalhoGridSinistros: [
            { text: 'Mercadoria', value: 'mercadoria'},
            { text: 'Valor do prejuízo', value: 'valorPrejuizo'},
            { text: 'Causa Do Sinistro', value: 'causaDoSinistro'},
            //{ text: 'UF', value: 'estado'},
            //{ text: 'Cidade', value: 'cidade'},
            { text: 'Data', value: 'data'},
            //{ text: 'Obs', value: 'obs'}
        ],
        estadosCountExec: -1,
        cidadeCountExec: -1
      }
  },
  computed: {
    
  },
  methods: {
    toPercentString: function (val) {
        return CustomFormat.toPercentString(val);
    },
    toPercentTaxaString: function (val) {
        return CustomFormat.toPercentTaxaString(val);
    },
    toMoneyString: function (val) {
        return CustomFormat.toMoneyString(val);
    },
    toLocaleDateString: function (val) {
        return CustomFormat.toLocaleDateString(val);
    },
    getSiglaEstado: function (idEstado, index) {
        const self = this;
        if (self.estados[index] == undefined && self.model && idEstado != undefined && index != undefined && self.estadosCountExec < index) {
            self.carregaEstado(idEstado, index);
            self.estadosCountExec++;
        } else if (self.estados[index] != undefined && index != undefined) {
            return self.estados[index].sigla;
        } else {
            return null;
        }
    },
    getNomeCidade: function (idCidade, index) {
        const self = this;
        if (self.cidades[index] == undefined && self.model && idCidade != undefined && index != undefined && self.cidadeCountExec < index) {
            self.carregaCidade(idCidade, index);
            self.cidadeCountExec++;
        } else if (self.cidades[index] != undefined && index != undefined) {
            return self.cidades[index].cidadeModel.nome;
        } else {
            return null;
        }
    },
    carregaEstado: async function (idEstado, index) {
        const self = this;
        if (self.estados[index] == undefined) {
            await axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaEstado?id=${idEstado}`)
            .then((response) => {
                self.estados.push(Object.assign({}, response.data));
            });
        }
    },
    carregaCidade: async function (idCidade, index) {
        const self = this;
        if (self.cidades[index] == undefined) {
            await axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaCidadePorId?idcidade=${idCidade}`)
            .then((response) => {
                self.cidades.push(Object.assign({}, response.data));
            });
        }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/SegurosAnteriores.vue